import React, { Component } from 'react'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'

import { fetchBrokerCoverageGeoJson } from 'broker/redux/broker_coverage'
import { selectBrokerCoverageGeoJson, selectBrokerCoverageLoading } from 'broker/selectors/broker_coverage'

import Card from 'broker/views/components/Card'
import RawCardSection from 'broker/views/components/CardSection'
import SCMapBox from 'broker/views/components/SCMapBox'

import OpButton from 'common/views/components/OpButton'

const StyledCardSection = styled(RawCardSection)`
  padding: 0;
`

const CardSection = connect(createStructuredSelector({
  loading: selectBrokerCoverageLoading
}))(StyledCardSection)


class BrokerCoverageCard extends Component {
  componentDidMount() {
    this.props.fetchBrokerCoverageGeoJson()
  }

  render() {
    const { geoJson, dispatch, navigateToManageUsers } = this.props

    return (
      <Card>
        <CardSection
          title="Agent Coverage"
          renderActionButton={() => (<OpButton onClick={navigateToManageUsers} bsStyle={'secondary-blue'}>Invite Agents</OpButton>)}
          nopad
        >
          <SCMapBox height={'284px'} width={'100%'} geo_json={geoJson} dispatch={dispatch} />
        </CardSection>
      </Card>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  geoJson: selectBrokerCoverageGeoJson
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  fetchBrokerCoverageGeoJson: () => dispatch(fetchBrokerCoverageGeoJson()),
  navigateToManageUsers: () => dispatch(push({pathname:'/add-users'}))
})

export default connect(mapStateToProps, mapDispatchToProps)(BrokerCoverageCard)
